import { gql } from '@apollo/client';

export const TALENT_LANGUAGE_FRAGMENT = gql`
    fragment talentLanguageFragment on TalentLanguage {
        _id
        talentId
        languages {
            languageId
            levelId
            certificateLanguges
        }
    }
`;

export const ADD_TALENT_LANGUAGE = gql`
    mutation AddTalentLanguage($request: RequestTalentLanguage, $talentId: ID) {
        addTalentLanguage(request: $request, talentId: $talentId) {
            ...talentLanguageFragment
        }
    }
    ${TALENT_LANGUAGE_FRAGMENT}
`;

export const UPDATE_TALENT_LANGUAGE = gql`
    mutation UpdateTalentLanguage($request: RequestTalentLanguage, $talentId: ID) {
        updateTalentLanguage(request: $request, talentId: $talentId) {
            ...talentLanguageFragment
        }
    }
    ${TALENT_LANGUAGE_FRAGMENT}
`;

export const DELETE_TALENT_LANGUAGE = gql`
    mutation DeleteTalentLanguage($id: ID!, $talentId: ID) {
        deleteTalentLanguage(id: $id, talentId: $talentId) {
            ...talentLanguageFragment
        }
    }
    ${TALENT_LANGUAGE_FRAGMENT}
`;

const LANGUAGE_FRAGMENT = gql`
    fragment LanguageFragment on Language {
        _id
        code
        original_letter
        name
    }
`;

const LEVEL_LANGUAGE_FRAGMENT = gql`
    fragment LevelLanguageFragment on LevelLanguage {
        _id
        level
        score
    }
`;

export const GET_DATA_TRANSFORM_LANGUAGE = gql`
    query GetAllLevelLanguage {
        getDataTransformLanguage {
            language {
                ...LanguageFragment
            }
            levelLanguage {
                ...LevelLanguageFragment
            }
        }
    }
    ${LANGUAGE_FRAGMENT}
    ${LEVEL_LANGUAGE_FRAGMENT}
`;

export const GET_DATA_LANGUAGE_PAGINATION = gql`
    query GetWithPagination($pagination: Pagination, $sortBy: String, $query: String) {
        getWithPagination(pagination: $pagination, sortBy: $sortBy, query: $query) {
            docs {
                ...LanguageFragment
            }
            meta {
                totalDocs
                limit
                page
                nextPage
                prevPage
                totalPages
                hasPrevPage
                hasNextPage
                pagingCounter
            }
        }
    }
    ${LANGUAGE_FRAGMENT}
`;

export const GET_ALL_LANGUAGE = gql`
    query GetAllLanguage {
        getAllLanguage {
            ...LanguageFragment
        }
    }
    ${LANGUAGE_FRAGMENT}
`;
